exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mma-alert-emails .b-form-tag > .b-form-tag-content.text-truncate[data-v-3c7c27c7] {\n  font-size: 14px;\n  line-height: 130%;\n}\n.mma-alert-emails .b-form-tag > button.b-form-tag-remove[data-v-3c7c27c7] {\n  font-size: 16px;\n  line-height: 130%;\n  padding: 0 5px;\n}\n.b-form-tag[data-v-3c7c27c7] {\n  font-family: \"sau-roboto-light\";\n}", ""]);

// exports
